import { FiMoreVertical } from 'react-icons/fi'
import moment from 'moment'
import { Button, Spinner } from '../../../UI'

export const columns = ({
  handleDisplayMenu,
  activePopup,
  handleDelete,
  handleEdit,
  deleteLoading,
}) => [
  {
    title: 'Rider Name',
    render: (item) => `${item.firstName || ''} ${item.lastName || ''}`.trim(),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    responsive: ['md'],
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
  },
  {
    title: 'Vehicle',
    dataIndex: 'vehicleType',
    responsive: ['lg'],
  },
  {
    title: 'Status',
    dataIndex: 'assignmentStatus',
    render: (status) => status || 'UNASSIGNED',
    responsive: ['md'],
  },
  {
    title: 'Action',
    align: 'center',
    render: (row, id) => (
      <div className="action-container">
        {deleteLoading === row.id ? (
          <Spinner />
        ) : (
          <Button
            icon
            arial-label="show menu"
            style={{ marginRight: '2em' }}
            className="btn-showMore"
            onClick={(e) => {
              e.stopPropagation()
              handleDisplayMenu(row, id)
            }}
          >
            <FiMoreVertical style={{ pointerEvents: 'none' }} />
          </Button>
        )}
        {activePopup === id &&  (
          <div className="action-popup">
             <button onClick={() => handleEdit(row)}>View Details</button>
          </div>
        )}
      </div>
    ),
  },
]
